import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IEthnicity from '../interfaces/IEthnicity';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IEthnicity>();
  const fields = [
      { name: 'name', type: 'string'},
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'ethnicity'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'Ethnicity successfully created!'}  
        title={'Add ethnicity'}  
        subheader={'Add ethnicity'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
